<button
  class="bg-white box-border content-stretch flex gap-2 items-center justify-start px-8 py-6 relative shrink-0 w-full hover:bg-gray-50 transition-colors duration-200 ease-in-out"
  [class.opacity-50]="menuItem.disabled"
  [class.cursor-pointer]="!menuItem.disabled"
  [class.cursor-not-allowed]="menuItem.disabled"
  [class.hover:bg-gray-100]="!menuItem.disabled"
  [disabled]="menuItem.disabled"
  (click)="onItemClick()"
  (keydown.enter)="onItemClick()"
  (keydown.space)="onItemClick()"
  [attr.aria-label]="menuItem.label"
  [attr.aria-disabled]="menuItem.disabled"
  type="button"
  tabindex="0"
  [ngClass]="menuItem.cssClass"
>
  <!-- Icona SVG -->
  <div
    *ngIf="menuItem.iconType === 'svg'"
    class="overflow-clip relative shrink-0 size-6"
  >
    <svg-icon
      [src]="menuItem.icon"
      class="w-6 h-6 text-slate-950 [&_svg]:stroke-[#020617]"
      [svgAriaLabel]="''"
    />
  </div>

  <!-- Icona PNG/Immagine -->
  <div
    *ngIf="menuItem.iconType === 'png'"
    class="overflow-clip relative shrink-0 size-6"
  >
    <img
      [src]="menuItem.icon"
      [alt]="menuItem.label"
      class="w-6 h-6"
    />
  </div>

  <!-- Avatar con iniziali -->
  <ape-avatar
    *ngIf="menuItem.iconType === 'avatar' && menuItem.firstName && menuItem.lastName"
    [forename]="menuItem.firstName"
    [surname]="menuItem.lastName"
    [image]="menuItem.image"
    [variant]="'simple'"
  />

  <!-- Testo della voce -->
  <div
    class="basis-0 box-border content-stretch flex flex-col grow items-start justify-start min-h-px min-w-px pb-0 pt-0.5 px-0 relative shrink-0"
  >
    <div class="font-normal text-base leading-base text-slate-950 relative shrink-0 w-full text-left">
      <p>{{ menuItem.label | translate }}</p>
    </div>
  </div>
</button>